function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5,3A15.5,15.5,0,1,0,34,18.5,15.5,15.5,0,0,0,18.5,3ZM9.458,27.724c1.507-4.521,6.028-2.756,6.781-5.205V20.886a4.31,4.31,0,0,1-1.41-2.409c-.267-.023-.686-.288-.81-1.336a.991.991,0,0,1,.356-.978,5.194,5.194,0,0,1-.4-1.807c0-2.676,1.327-4.9,4.522-4.9a2.378,2.378,0,0,1,2.26,1.223c1.542,0,2.26,1.691,2.26,3.673a4.6,4.6,0,0,1-.4,1.807.988.988,0,0,1,.358.978c-.124,1.048-.542,1.312-.81,1.336a4.3,4.3,0,0,1-1.41,2.409v1.633c.753,2.45,5.274.686,6.781,5.207a12.915,12.915,0,0,1-18.083,0Z",
  transform: "translate(-3 -3)"
});

var SvgProfileIcon = function SvgProfileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile_icon.74ffa6ed.svg";
export { ForwardRef as ReactComponent };